import type { Dispatch } from "react";
import { ScheduleViewStateDispatchContext } from "@/pages/human-resources/time-management/model/schedule-view/ScheduleViewStateDispatchContext.ts";
import type { ScheduleViewAction } from "@/pages/human-resources/time-management/model/schedule-view/ScheduleViewAction.ts";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";

export default function useScheduleViewStateDispatch(): {
  dispatch: Dispatch<ScheduleViewAction>;
  callback: (a: ScheduleViewAction) => () => void;
} {
  const dispatch = useDefinedContextValue(ScheduleViewStateDispatchContext);
  return {
    dispatch,
    callback: (a: ScheduleViewAction): (() => void) => {
      return () => {
        dispatch(a);
      };
    },
  };
}
